import React, { useCallback } from 'react';
import { Stack, Text } from '@televet/kibble-ui';
import useClinicUser from 'shared/hooks/useClinicUser';
import { RetryCampaignButton } from './RetryCampaignButton';
import StartTwilioRegistration from './StartTwilioRegistration';
import { TWILIO_STATUS } from 'shared/enums/TwilioStatus';

interface A2PRegistrationStatusSectionProps {
  canBeTwilioRegistered: boolean;
  isClinicSoleProp: boolean;
  brand: {
    message: string;
    status: string;
  };
  messagingService: {
    message: string;
    status: string;
  };
  campaign: {
    message: string;
    status: string;
  };
}

export const A2PRegistrationStatusSection = ({
  canBeTwilioRegistered,
  isClinicSoleProp,
  brand,
  messagingService,
  campaign,
}: A2PRegistrationStatusSectionProps): JSX.Element => {
  const { currentClinic } = useClinicUser();

  const getStatusColor = useCallback((status) => {
    switch (status) {
      case TWILIO_STATUS.APPROVED:
        return 'text.success';
      case TWILIO_STATUS.FAILED:
        return 'text.danger';
      default:
        return 'text.warning';
    }
  }, []);
  return currentClinic?.twilioConfiguration && brand?.status !== TWILIO_STATUS.NOTFOUND ? (
    <Stack ml="2">
      <Text color={getStatusColor(messagingService?.status)}>
        <strong>Overall Status:</strong> {messagingService?.status}
      </Text>
      <Text pl="15">{messagingService?.message}</Text>
      <Text color={getStatusColor(brand?.status)}>
        <strong>Brand Registration Status:</strong> {brand?.status}
      </Text>
      <Text pl="15">{brand?.message}</Text>
      <Text color={getStatusColor(campaign?.status)}>
        <strong>Campaign Registration Status:</strong> {campaign?.status}{' '}
        {campaign?.status === TWILIO_STATUS.NOTFOUND && brand?.status === TWILIO_STATUS.APPROVED && (
          <RetryCampaignButton />
        )}
      </Text>

      <Text pl="15">{campaign?.message}</Text>
    </Stack>
  ) : (
    <Stack>
      <em>(This can be done without a phone number)</em>
      <StartTwilioRegistration
        canBeTwilioRegistered={canBeTwilioRegistered}
        isClinicSoleProp={isClinicSoleProp}
        twilioConfig={currentClinic?.twilioConfiguration}
      />
    </Stack>
  );
};
